<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
        :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
      <el-dialog
          width="50%"
          title="图标管理"
          :visible.sync="innerVisible"
          append-to-body>
        <div class="menuTool" style="width:100%;margin-bottom:30px;">
          <el-card class="box-card">
            <el-row :gutter="5">
              <el-col :span="4" v-for="item in IconTableData" :key="item.id">
                <el-card :body-style="{ padding: '0px' }">
                  <div class="iconPosition">
                    <img :alt="item.iconName" :src="item.iconHref">
                  </div>
                  <div style="padding: 14px;">
                    <span class="iconNamePosition" :title="item.iconName">{{ item.iconName }}</span>
                    <div class="bottom clearfix">
                      <el-button type="text" @click="delMenu(item)" class="button" style="font-size:14px;">选择
                      </el-button>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-card>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              style="float:right;margin-top:25px;margin-bottom:25px;">
          </el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="ChangeCore()">确 定 </el-button>
      </span>
      </el-dialog>
      <div style="width:70%;margin-left:5%;" v-if="title == '修改'">
        <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;">
          <el-form-item label="上级菜单：">
            <el-cascader
                :props="{ checkStrictly: true }"
                v-model="value"
                :options="menuTree"
                :show-all-levels="false"
                @change="handleChange(value)"></el-cascader>
          </el-form-item>
          <el-form-item label="名称：">
            <el-input v-model="formLabelAlign.name" size="small"></el-input>
          </el-form-item>
          <el-form-item label="链接：">
            <el-input v-model="formLabelAlign.href" size="small"></el-input>
          </el-form-item>
          <el-form-item label="目标：">
            <el-input v-model="formLabelAlign.target" size="small"></el-input>
          </el-form-item>
          <el-form-item label="排序：">
            <el-input v-model="formLabelAlign.sort" size="small"></el-input>
          </el-form-item>
          <el-form-item label="图标：">
            <el-input v-model="IconinputS" style="width:78%;float:left;" disabled placeholder="点击右侧按钮选择图标">
            </el-input>
            <el-button icon="el-icon-s-tools" style="float:right" @click="selectIcons"></el-button>
          </el-form-item>
          <el-form-item label="可见：">
            <el-radio v-model="display" label="1">显示</el-radio>
            <el-radio v-model="display" label="2">隐藏</el-radio>
          </el-form-item>
          <el-form-item label="日志：">
            <el-radio v-model="log" label="1">保存</el-radio>
            <el-radio v-model="log" label="2">忽略</el-radio>
          </el-form-item>
          <el-form-item label="权限标识：">
            <el-input v-model="formLabelAlign.permission" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>


      <div style="width:70%;margin-left:5%;" v-if="title == '添加下级菜单'">

        <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;">
          <el-form-item label="上级菜单：">
            <el-cascader
                :props="{ checkStrictly: true }"
                v-model="value"
                :options="menuTree"
                :show-all-levels="false"
                @change="handleChange(value)"></el-cascader>
          </el-form-item>
          <el-form-item label="名称：">
            <el-input v-model="formLabelAlign.name" size="small"></el-input>
          </el-form-item>
          <el-form-item label="链接：">
            <el-input v-model="formLabelAlign.href" size="small"></el-input>
          </el-form-item>
          <el-form-item label="目标：">
            <el-input v-model="formLabelAlign.target" size="small"></el-input>
          </el-form-item>
          <el-form-item label="排序：">
            <el-input v-model="formLabelAlign.sort" size="small"></el-input>
          </el-form-item>
          <el-form-item label="图标：">
            <el-input v-model="IconinputS" style="width:78%;float:left;" disabled placeholder="点击右侧按钮选择图标">
            </el-input>
            <el-button icon="el-icon-s-tools" style="float:right" @click="selectIcons"></el-button>
          </el-form-item>
          <el-form-item label="菜单类型：">
            <el-radio v-model="menuType" label="1">Web</el-radio>
            <el-radio v-model="menuType" label="2">App</el-radio>
          </el-form-item>
          <el-form-item label="可见：">
            <el-radio v-model="display" label="1">显示</el-radio>
            <el-radio v-model="display" label="2">隐藏</el-radio>
          </el-form-item>
          <el-form-item label="日志：">
            <el-radio v-model="log" label="1">保存</el-radio>
            <el-radio v-model="log" label="2">忽略</el-radio>
          </el-form-item>
          <el-form-item label="权限标识：">
            <el-input v-model="formLabelAlign.permission" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="width:90%;margin-left:5%;" v-if="title == '查看'">
        <el-table tooltip-effect="light" :data="tableData"
                  style="overflow-y: scroll;float:right;margin-top:30px"
                  row-key="id" border :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
          <el-table-column show-overflow-tooltip prop="roleName" label="角色名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="officeName" label="归属机构"></el-table-column>
          <el-table-column show-overflow-tooltip prop="dataScopeName" label="数据范围"></el-table-column>
        </el-table>
      </div>
      <div style="width:70%;margin-left:5%;" v-if="title == '添加'">
        <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;">
          <el-form-item label="上级菜单：">
            <el-cascader
                :props="{ checkStrictly: true }"
                v-model="value"
                :options="menuTree"
                :show-all-levels="false"
                @change="handleChange(value)"></el-cascader>
          </el-form-item>
          <el-form-item label="名称：">
            <el-input v-model="formLabelAlign.name" size="small"></el-input>
          </el-form-item>
          <el-form-item label="链接：">
            <el-input v-model="formLabelAlign.href" size="small"></el-input>
          </el-form-item>
          <el-form-item label="目标：">
            <el-input v-model="formLabelAlign.target" size="small"></el-input>
          </el-form-item>
          <el-form-item label="排序：">
            <el-input v-model="formLabelAlign.sort" size="small"></el-input>
          </el-form-item>
          <el-form-item label="图标：">
            <el-input v-model="IconinputS" style="width:78%;float:left;" disabled placeholder="点击右侧按钮选择图标">
            </el-input>
            <el-button icon="el-icon-s-tools" style="float:right" @click="selectIcons"></el-button>
          </el-form-item>
          <el-form-item label="菜单类型：">
            <el-radio v-model="menuType" label="1">Web</el-radio>
            <el-radio v-model="menuType" label="2">App</el-radio>
          </el-form-item>
          <el-form-item label="可见：">
            <el-radio v-model="display" label="1">显示</el-radio>
            <el-radio v-model="display" label="2">隐藏</el-radio>
          </el-form-item>
          <el-form-item label="日志：">
            <el-radio v-model="log" label="1">保存</el-radio>
            <el-radio v-model="log" label="2">忽略</el-radio>
          </el-form-item>
          <el-form-item label="权限标识：">
            <el-input v-model="formLabelAlign.permission" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "MenuManagementDialog",
  components: {},
  data() {
    return {
      dialogVisible: false,
      title: "标题",

      menuTree: [],
      value: [],


      parentId: "",
      formLabelAlign: {},
      labelPosition: 'right',

      display: '2',
      log: '2',
      tableData: [],
      options: [],
      Iconinput: "",

      iconChooseVisible: false,
      menuType: '1',
      menuTypeone: "",


      innerVisible: false,
      IconTableData: [],
      total: 0,//默认数据总数
      pagesize: 10,//每页的数据条数
      currentPage: 1,//默认开始页面
      IconData: {},
      IconinputS: "",
    };
  },
  watch:{
    dialogVisible(val){
      if(val == true){
        for(let val of this.menuTree){
          if(val.children.length > 0){
            for(let res of val.children){
              if(res.id == this.value[0]){
                this.value.unshift(res.parentId)
              }
            }
          }
        }
        this.typeST()
      }
    }
  },
  methods: {
    typeST(){
        let obj = {
              "type":"sys_menu_type",
              "del_flag":"0"
            }
            this.$http.post(this.$requestUrl.POST_USER_TYPE,obj).then((res) => {
            let result = res.data;
            if (200 === result.code) {
              // console.log(res)
            }else{
              this.$message.error(result.msg)
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
    },
    selectIcons() {
      this.innerVisible = true
    },
    handleIconCancel() {
      this.iconChooseVisible = false
      this.dialogVisible = true
    },
    handleIconChoose(value) {
      this.Iconinput = value
      this.dialogVisible = true
      this.iconChooseVisible = false
    },
    ChangeCore() { // 内层确定
      this.innerVisible = false
      this.IconinputS = this.IconData.iconName
      this.Iconinput = this.IconData.iconHref
    },
    modification() {  // 确定
      let menuType = this.menuType
      if (menuType == "1") {
        this.menuTypeone = "web"
      } else {
        this.menuTypeone = "app"
      }
      if (this.title == "查看") {
        this.dialogVisible = false
      } else {
        if (this.formLabelAlign.name != "" || this.formLabelAlign.name != null || this.formLabelAlign.name != undefined) {
          if (this.formLabelAlign.sort != "" || this.formLabelAlign.sort != null || this.formLabelAlign.sort != undefined) {
            if (this.title == "修改") {
              let obj = {
                "id": this.formLabelAlign.id,
                "parentId": this.parentId,
                "name": this.formLabelAlign.name,
                "icon": this.Iconinput,
                "sort": this.formLabelAlign.sort * 1,
                "href": this.formLabelAlign.href,
                "target": this.formLabelAlign.target,
                "isShow": this.display,
                "isLog": this.log,
                "permission": this.formLabelAlign.permission,
              }
              this.$http.put(this.$requestUrl.POST_MENU_UP, obj).then((res) => {
                let result = res.data;
                if (200 === result.code) {
                  this.$emit("dialog", false)
                  this.dialogVisible = false
                  this.$message({
                    message: '修改成功',
                    type: 'success'
                  });
                } else {
                  this.$message.error(result.msg)
                }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
            } else if (this.title == "添加") {
              for (let i = 0; i < this.value.length; i++) {
                this.parentId = this.value[i]
              }
              let obj = {
                "parentId": this.parentId,
                "name": this.formLabelAlign.name,
                "icon": this.Iconinput,
                "sort": this.formLabelAlign.sort * 1,
                "href": this.formLabelAlign.href,
                "target": this.formLabelAlign.target,
                "isShow": this.display,
                "isLog": this.log,
                "permission": this.formLabelAlign.permission,
                "menuType": this.menuTypeone
              }
              this.$http.post(this.$requestUrl.POST_MENU_ADD, obj).then((res) => {
                let result = res.data;
                if (200 === result.code) {
                  this.$emit("dialog", false)
                  this.dialogVisible = false
                  this.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                } else {
                  this.$message.error(result.msg)
                }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
            } else if (this.title == "添加下级菜单") {
              for (let i = 0; i < this.value.length; i++) {
                this.parentId = this.value[i]
              }
              let obj = {
                "parentId": this.parentId,
                "name": this.formLabelAlign.name,
                "icon": this.Iconinput,
                "sort": this.formLabelAlign.sort * 1,
                "href": this.formLabelAlign.href,
                "target": this.formLabelAlign.target,
                "isShow": this.display,
                "isLog": this.log,
                "permission": this.formLabelAlign.permission,
                "menuType": this.menuTypeone
              }
              this.$http.post(this.$requestUrl.POST_MENU_ADD, obj).then((res) => {
                let result = res.data;
                if (200 === result.code) {
                  this.dialogVisible = false
                  this.$emit("dialog", false)
                  this.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                } else {
                  this.$message.error(result.msg)
                }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
            }
          } else {
            this.$message({
              message: '请填写排序',
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: '请填写名称',
            type: 'warning'
          });
        }
      }
    },
    handleChange(val) {
      this.parentId = val[val.length - 1]
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    amend() {
      let obj = {
        "delFlag": "",
        "menuType": "0",
        "isShow": ""
      }
      this.$http.post(this.$requestUrl.GET_ALL_MENU, obj).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          if (result.data == null) {
          } else {
            for (let val of result.data) {
              val.label = val.name
              val.value = val.id
              if (val.children.length != 0) {
                this.circulation(val.children)
              }
            }
            this.menuTree = result.data;
          }
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    circulation(children) {
      for (let res of children) {
        res.label = res.name
        res.value = res.id
        if (res.children.length != 0) {
          this.circulation(res.children)
        }
      }
    },
    traverse(res) {
      for (let data of res) {
        data.label = data.name
        data.value = data.id
        if (data.children.length > 0) {
          this.traverse(data.children)
        } else if (data.children.length === 0) {
          delete data.children
        }
      }
    },
    handleSizeChange(val) {
      this.pagesize = val
      this.ShareList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.ShareList()
    },
    ShareList() {
      let PageSize = {
        "page": this.currentPage, // 当前页
        "size": this.pagesize,  // 每页大小
      }
      this.$http.post(this.$requestUrl.ICON_POST_LIST, PageSize).then((res) => {
        let data = res.data;
        if (200 === data.code) {
          this.total = data.data.total
          this.IconTableData = data.data.records;
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    delMenu(data) {
      this.IconData = data
    }
  },
  mounted() {
    this.amend();
    this.ShareList()
  },
  //组件创建之后
  created() {

  },
  //页面渲染之前
  beforeMount() {

  },
}
</script>

<style scoped lang="scss">
.Icon {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px;


}
</style>
<style>
.el-cascader-node__label {
  color: black;
}

</style>